'use client';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Users, GraduationCap, Building2, Award } from 'lucide-react';

const stats = [
  { icon: Users, number: 5000, label: 'Students', suffix: '+' },
  { icon: GraduationCap, number: 50, label: 'Courses', suffix: '+' },
  { icon: Building2, number: 200, label: 'Companies', suffix: '+' },
  { icon: Award, number: 95, label: 'Placement', suffix: '%' },
];

export default function StatsSection() {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });

  return (
    <section ref={ref} className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              className="text-center"
              initial={{ opacity: 0, y: 30 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <stat.icon className="w-12 h-12 text-cyan-500 mx-auto mb-4" />
                <motion.div
                  className="text-3xl font-bold text-gray-900 mb-2"
                  initial={{ scale: 0 }}
                  animate={inView ? { scale: 1 } : {}}
                  transition={{ duration: 0.5, delay: index * 0.1 + 0.3 }}
                >
                  {stat.number}{stat.suffix}
                </motion.div>
                <div className="text-gray-600 font-medium">{stat.label}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}